import React from 'react';
import { Chord, Note, Scale } from 'tonal';
import instruments from '../data/instruments.json';
import { formatTuningDisplay } from '../utils/tuningHelpers';
import { useIsPWA } from '../hooks/useIsPWA';

interface MobileBottomNavProps {
  setActiveModal: (modal: 'instrument' | 'scale' | 'chord' | 'settings' | null) => void;
  selectedInstrument: string;
  tuningNotes: string[];
  capoFret: number;
  useCapo: boolean;
  selectedKey: string;
  scale: string;
  selectedChord: string;
  frets: number;
  rotation: number;
  isLeftHanded: boolean;
}

export const MobileBottomNav: React.FC<MobileBottomNavProps> = ({ 
  setActiveModal,
  selectedInstrument,
  tuningNotes,
  capoFret,
  useCapo,
  selectedKey,
  scale,
  selectedChord,
  frets,
  rotation,
  isLeftHanded
}) => {
  const isPWA = useIsPWA();
  const selectedChordNotes = selectedChord ? Chord.get(selectedChord).notes : [];
  const scaleNotes = selectedKey && scale ? Scale.get(`${selectedKey} ${scale}`).notes : [];
  
  return (
    <div className={`fixed bottom-0 left-0 right-0 bg-base-100 text-base-content md:hidden overflow-x-auto p-2 gap-2 ${isPWA ? 'pb-safe-lg px-3' : ''} flex z-50 `}>
      <button className="flex-1 flex flex-col items-start justify-start p-1 px-1 min-w-[20%] border-2 border-primary rounded-lg" onClick={() => setActiveModal('instrument')}>
        <div className="w-full flex flex-col items-center">
          <span className="text-xs font-bold w-full text-center text-primary">{selectedInstrument}</span>
          <div className="flex-1 flex flex-col items-center justify-center">
            <span className="text-xs">{formatTuningDisplay(instruments.find((inst) => inst.name === selectedInstrument), tuningNotes)}</span>
            <span className="text-xs">{useCapo ? `Capo: ${capoFret}` : 'No Capo'}</span>
          </div>
        </div>
      </button>
      <button className="flex-1 flex flex-col items-start justify-start p-1 px-1 min-w-[20%] border-2 border-secondary rounded-lg" onClick={() => setActiveModal('scale')}>
        <div className="w-full flex flex-col items-center">
          <span className="text-xs font-bold w-full text-center text-secondary">Scale</span>
          <div className="flex-1 flex flex-col items-center justify-center">
            <span className="text-xs">{selectedKey} {scale}</span>
            {scaleNotes.length > 0 && <span className="text-[0.6rem]">{`${scaleNotes.join(' ')}`}</span>}
          </div>
        </div>
      </button>
      <button className="flex-1 flex flex-col items-start justify-start p-1 px-1 min-w-[20%] border-2 border-accent rounded-lg" onClick={() => setActiveModal('chord')}>
        <div className="w-full flex flex-col items-center">
          <span className="text-xs font-bold w-full text-center text-accent">Chord</span>
          <div className="flex-1 flex flex-col items-center justify-center">
            <span className="text-xs">{selectedChord || 'None'}</span>
            {selectedChord && <span className="text-[0.6rem]">{`(${selectedChordNotes.join(', ')})`}</span>}
          </div>
        </div>
      </button>
    </div>
  );
};